import axiosClient from '@/api/axiosClient';
import {
  API_GET_CHAR_CORE,
  API_GET_CONFIG,
  API_UPDATE_CONFIG_GENERAL,
  API_UPDATE_CONFIG_INFO,
  API_UPDATE_CONFIG_SMS,
  API_UPDATE_DAILY_QUEST_BY_HEART,
  API_UPDATE_CONFIG_MESSAGE_BAR,
  API_UPDATE_EVENT_PROMOTION
} from '@/config/paths/API_PATH';

async function getConfig(params) {
  const { data } = await axiosClient.get(API_GET_CONFIG, {
    params,
  });
  return data;
}

async function updateConfigGeneral(formData) {
  const { data } = await axiosClient.post(API_UPDATE_CONFIG_GENERAL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
}

async function updateConfigInfo(formData) {
  const { data } = await axiosClient.post(API_UPDATE_CONFIG_INFO, formData);

  return data;
}

async function updateConfigMessageBar(formData) {
  const { data } = await axiosClient.put(API_UPDATE_CONFIG_MESSAGE_BAR, formData);
  return data;
}

async function updateConfigSms(formData) {
  const { data } = await axiosClient.post(API_UPDATE_CONFIG_SMS, formData);

  return data;
}

async function getCharCore() {
  const { data } = await axiosClient.get(API_GET_CHAR_CORE);

  return data;
}

async function updateConfigDailyQuestByHeart(formData) {
  const { data } = await axiosClient.put(API_UPDATE_DAILY_QUEST_BY_HEART, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return data;
}

async function updateConfigEventPromotion(formData) {
  const { data } = await axiosClient.put(API_UPDATE_EVENT_PROMOTION, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return data;
}

export {
  getConfig,
  updateConfigGeneral,
  updateConfigInfo,
  getCharCore,
  updateConfigSms,
  updateConfigDailyQuestByHeart,
  updateConfigMessageBar,
  updateConfigEventPromotion
};
